import React from "react";
import style from "./VrtSessionIndex.module.sass";

function VRTSessions({
  addNewText,
  createUrl,
  title,
  vrtSessions,
  onTerminateSessionUrl,
  activeSessionsLabel,
  detailUrlBase,
}) {
  const createNewSequence = () => {
    window.location.href = createUrl;
  };

  const onTerminateSession = async (e, session) => {
    e.preventDefault();
    console.log("Selected session:", session);

    let response = await fetch(onTerminateSessionUrl, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ session }),
    });
    const data = await response.json();

    if (response.ok) {
      window.location.href = data.redirectUrl;
    } else {
      console.error("Errore terminazione sessione:", data.errors);
    }
  };

  const viewSessionDetails = (sessionId) => {
    window.location.href = `${detailUrlBase}/${sessionId}`;
  };

  return (
    <div className={style.container}>
      <h2 className={style.title}>{title}</h2>
      {createUrl && (
        <div className={style.buttonGroup}>
          <button className={style.createButton} onClick={createNewSequence}>
            {addNewText}
          </button>
        </div>
      )}

      <h3 className={style.subtitle}>{activeSessionsLabel}</h3>
      <div className={style.sessionsList}>
        {vrtSessions.map((session, index) => (
          <div key={index} className={style.sessionItem}>
            <div className={style.sessionBadge}>
              <span
                className={style.educationalBadge}
              >
                {session.sessionTypology === "educational" ? "Educativa" : "Rilassante"}
              </span>
            </div>
            <div className={style.sessionDetails}>
              <div className={style.sessionInfo}>
              <span className={style.value}>{session.vrtDevice}</span>
                <span className={style.label}>Visore</span>

              </div>
              <div className={style.sessionInfo}>
                <span className={style.value}>{session.patientId}</span>
                <span className={style.label}>Utente</span>

              </div>
            </div>
            <div className={style.buttonGroup}>
              <button
                className={style.detailButton}
                onClick={() => viewSessionDetails(session.id)}
              >
                &#128065; Dettagli
              </button>
              <button
                className={style.terminateButton}
                onClick={(e) => onTerminateSession(e, session.id)}
              >
               Termina
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default VRTSessions;
